import { AppointmentOptionsModalKeys } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/variants/_components/appointment-options/appointment-options-button.component';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { Appointment } from '@/types/appointments.types';
import { AppointmentsLifecycleEnum } from '@/types/enums/appointments.enum';

interface AppointmentConfirmCancelProps {
  lifecycle: AppointmentsLifecycleEnum;
  appointment: Appointment;
}

export const AppointmentConfirmCancel = ({ lifecycle, appointment }: AppointmentConfirmCancelProps) => {
  const { handleJump } = useProgressiveModal<AppointmentOptionsModalKeys>();

  const canChangeDate = lifecycle != AppointmentsLifecycleEnum.OTHER;

  return (
    <div className="flex flex-col gap-2">
      <Typography variant={TypographyVariant.BODY_TEXT} className="text-gray-800 font-bold mb-3">
        Solicitar cancelamento
      </Typography>
      <Typography variant={TypographyVariant.BODY_TEXT} className="mb-3">
        Precisa trocar algum detalhe sobre o agendamento? Confira as opções que temos para você:
      </Typography>
      {canChangeDate && (
        <Button onClick={() => handleJump({ key: AppointmentOptionsModalKeys.CHANGE_DATE, returning: true })}>
          Trocar data ou hora
        </Button>
      )}
      <Button onClick={() => handleJump({ key: AppointmentOptionsModalKeys.CHANGE_PATIENT_LIST, returning: true })}>
        Trocar paciente
      </Button>
      <Button asChild color="danger">
        <Link prefetch={false} href={`/agendamentos/${appointment.id}/solicitar-cancelamento/`}>Quero solicitar cancelamento</Link>
      </Button>
    </div>
  );
};
